module.exports = __webpack_public_path__ + "img/construction.b8d6423c.svg";